import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { MouseEvent } from "react";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import type { CreatorCounts } from "../hooks/useWorkbookCreatorCounts";

type CreatorOption = "all" | "createdByMe";

interface Props {
  createdByMe: boolean;
  counts: CreatorCounts | undefined;
  onChange: (createdByMe: boolean) => void;
}

const WorkbookCreatorFilter = ({ createdByMe, counts, onChange }: Props) => {
  const handleChange = (_: MouseEvent<HTMLElement>, value: CreatorOption | null) => {
    if (value) {
      onChange(value === "createdByMe");
    }
  };

  return (
    <ToggleButtonGroup value={createdByMe ? "createdByMe" : "all"} exclusive onChange={handleChange}>
      <ToggleButton value="all" sx={{ gap: 0.5 }}>
        All
        {counts && <BadgeDetached showZero badgeContent={counts.all} color="secondary" />}
      </ToggleButton>
      <ToggleButton value="createdByMe" sx={{ gap: 0.5 }}>
        Created by Me
        {counts && <BadgeDetached showZero badgeContent={counts.createdByMe} color="secondary" />}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default WorkbookCreatorFilter;
